import styled, { css } from 'styled-components';
import { Colors, toRem } from '../../ui';
import { Shadows } from '../../ui/Standards';

const Header = styled.div`
    position: relative;
    display: flex;
    align-items: start;
    justify-content: space-between;

    svg {
        width: 2.5rem;
        height: 2.5rem;
    }
`;

const Label = styled.div`
    margin: .25rem;
    color: ${Colors.text};
    font-size: 1.125rem;
    font-weight: 400;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const Description = styled.div`
    margin: .25rem;
    margin-top: 0;
    color: ${Colors.textLighter};
    font-size: .875rem;
    font-weight: 400;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const Main = styled.div`
    position: relative;
    padding: 1rem;
    border: solid .125rem #DDE2EC;
    border-radius: .75rem;
    background: white;
    overflow: hidden;
    cursor: pointer;
`;

const Footer = styled.div`
    display: flex;
    align-items: center;
`;

const ActionMenu = styled.div`
    position: absolute;
    top: 1rem;
    right: .5rem;
    z-index: 1;
`;

const Base = styled.div<{ width?: string | number, height?: string | number, clickable?: boolean, dropping?: boolean }>`
    width: ${p => toRem(p.width || 20)};

    ${Main} {
        width: ${p => toRem(p.width || 20)};
        height: ${p => toRem(p.height || (parseInt(p.width as any) || 20) * .425)};
    }

    ${p => p.clickable && css`
        ${Main} {
            transition: box-shadow .15s ease-out;

            &:hover {
                border: solid .125rem ${Colors.textLightest};
                box-shadow: ${Shadows.md};
                transition: none;
            }
            &:active {
                background: #fcfcfc;
            }
        }
    `}

    ${p => p.dropping && css`
        ${Main} {
            border: solid .125rem ${Colors.primaryLight} !important;
            box-shadow: 0 0 0 .125rem ${Colors.primaryLight} !important;
        }
    `}
`;

export const FolderItem = Object.assign(Base, {
    Header,
    Main,
    Footer,
    Label,
    Description,
    ActionMenu,
});
